function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCloudRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 8a6.018 6.018 0 015.627 3.94l.657 1.794 1.822-.574a2.932 2.932 0 013.76 3.648l-.356 1.263 1.017.83A3.999 3.999 0 0124 26H9a4.996 4.996 0 01-2.117-9.523l1.258-.59-.114-1.384A6.102 6.102 0 018 14a6.007 6.007 0 016-6zm0-2a8 8 0 00-8 8c0 .225.016.446.034.666A6.996 6.996 0 009 28h15a5.998 5.998 0 003.791-10.648c.132-.44.202-.894.209-1.352a5 5 0 00-5-5 4.95 4.95 0 00-1.495.253A7.995 7.995 0 0014 6z",
    fill: props.color
  }));
}

export default SvgIconCloudRexOutline;